/* Waxman's Gym Ratio Calculator Copyright (C) 2017 Waxman's Gym

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.*/

import React, { Component } from 'react';
import { formatNumber, isNumber } from '../helpers.js';
import { ranges, diagnoses, prescriptions } from '../data.js';
var _ = require('lodash');

class AccessoryResults extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        if (!isNumber(this.props.base)) {
            return null;
        }

        let results = _.map(this.props.accessories, (accessory, accessoryName) => {
            let actualRatio = accessory.value / this.props.base * 100;
            return {
                name: accessoryName,
                actualRatio: actualRatio,
                expectedRatio: accessory.ratio,
                ratioDiff: actualRatio - accessory.ratio,
                value: Number(accessory.value)
            };
        });

        let analysisName = "Análise " + this.props.baseName;

        let resultsContent = null;
        if (results.length === 0) {
            resultsContent = (<span>Por favor insira um ou mais valores para os exercícios acessórios</span>);
        }
        else {
            let notes = (<span></span>);

            let worst = _.maxBy(results, (r) => Math.abs(r.ratioDiff));
            let whichWay = worst.ratioDiff < 0 ? 'too_low' : 'too_high';
            let diagnosis = diagnoses[worst.name][whichWay];
            let prescription = prescriptions[worst.name][whichWay];
            let showWork = true;
            let extraWork = null;

            // ######################################################################
            // TODO: As the rule tree becomes more complex, more and more logic made its way here.
            // All diagnoses/prescriptions should just be moved out of the data.js file and into
            // here so that it's all in one place
            // ######################################################################

            // Grab the front squat entry from the list of results as we use it all over the place
            let frontSquat = _.find(results, (r) => { return r.name === 'Front Squat'; });

            let jerk = _.find(results, (r) => { return r.name === 'Jerk'; });
            let clean = _.find(results, (r) => { return r.name === 'Clean'; });

            // The "acceptable" range for the front squat in %
            let frontSquatAcceptableRange = 5.0;

            let shortExplanation = null;

            // Special case for when all of the lifts are within the ideal range.
            if (Math.abs(worst.ratioDiff) <= ranges.ideal) {
                if (results.length === 1) {
                    diagnosis = (
                        <span>
                            Parabéns, seu {worst.name} esta em um equilíbrio ideal.
                            Como este é o único exercício acessório que você inseriu, isso não nos diz muito.
                        </span>
                    );

                    prescription = (
                        <span>
                            Por favor insira mais de um exercício acessório e refaça a análise.
                        </span>
                    );
                }
                else {
                    showWork = false;
                    diagnosis = (
                        <span>
                            Todos os exercícios que você inseriu parecem estar em um equilíbrio ideal, parabéns!
                        </span>
                    );

                    prescription = (
                        <span>
                            A maneira como você está treinando atualmente parece estar lhe deixando equilibrado, continue assim.
                        </span>
                    );
                }
            }
            else if (worst.name !== 'Jerk' && jerk !== undefined && clean !== undefined && jerk.value < clean.value) {

                // Don't show the "how did we get this" info
                extraWork = (
                    <p>
                        Mesmo que você consiga fazer um clean com mais carga do que um Jerk, não importa muito o seu equilíbrio ou outras relações de peso, você vai precisar melhorar seu Jerk para aumentar sua carga no Clean &amp; Jerk.
                    </p>)

                if (frontSquat === undefined) {
                    // Jerk lower than clean, but another ratio shows greater disparity (and no front squat entered)
                    diagnosis = (
                        <span>
                            <p>
                                Enquanto sua maior disparidade nas relações de carga é o seu {worst.name} comparado com o seu Clean &amp; Jerk, seu Jerk atualmente é menor do que seu
                                Clean. Para propósitos de melhoria do seu Clean &amp; Jerk, o Jerk deve ser sua prioridade.
                            </p>
                            <p>
                                Como você não inseriu um valor de front squat, é difícil para nós diagnosticar os problemas do Jerk.
                                Se o seu squat está em um nível adequado, os problemas com seu Jerk estão relacionados a técnica.
                                Se o nível do seu squat está abaixo do ideal, o seu problema pode ser força ou geração de potência.
                            </p>
                        </span>
                    );
                    prescription = (
                        <span>
                            Por favor insira o valor do seu front squat e refaça a análise.
                        </span>
                    );
                }
                else if (frontSquat.ratioDiff >= frontSquatAcceptableRange) {
                    // Jerk lower than clean, another ratio shows greater disparity (and front squat ratio is
                    // within range or higher than ideal)
                    diagnosis = (
                        <span>
                            <p>
                                Enquanto sua maior disparidade nas relações de carga é o seu {worst.name} comparado com o seu Clean &amp; Jerk, seu Jerk atualmente é menor do que seu
                                Clean. Para propósitos de melhoria do seu Clean &amp; Jerk, o Jerk deve ser sua prioridade.
                            </p>
                            <p>
                                Como aparentemente não é a força que está limitando o seu Jerk (de acordo com seus dados de Front Squat),
                                provavelmente você possui uma técnica de Jerk ineficiente.
                            </p>
                        </span>
                    );
                    prescription = (
                        <span>
                            <p>
                                Como há uma grande quantidade de quesitos técnicos que podem estar atrapalhando o seu Jerk,
                                é difícil dizer com os dados informados qual aspecto técnico você precisa melhorar (como por exemplo, posição inadequada ou desequilíbrio, problemas de
                                quantidade ou direção da potência ou coordenação).
                            </p>
                            <p>
                                Nós recomendamos você a avaliar seus próprios movimentos em vídeo, ou buscar um coach
                                experiente para lhe ajudar a priorizar/corrigir suas deficiências técnicas, assim você
                                conseguirá aproveitar de melhor maneira sua força no Jerk.
                            </p>
                        </span>
                    );
                }
                else {
                    // Jerk lower than clean, another ratio shows greater disparity (and front squat ratio is
                    // within range or higher than ideal)
                    diagnosis = (
                        <span>
                            <p>
                                Enquanto sua maior disparidade nas relações de carga é o seu {worst.name} comparado com o seu Clean &amp; Jerk, seu Jerk atualmente é menor do que seu
                                Clean. Para propósitos de melhoria do seu Clean &amp; Jerk, o Jerk deve ser sua prioridade.
                            </p>
                            <p>
                                Como o seu front squat está abaixo do ideal quando comparado com seu Clean & Jerk, isso nos dá
                                a entender que seu Jerk está limitado pela falta de uma força primária.
                            </p>
                        </span>
                    );
                    prescription = (
                        <span>
                            Você conseguirá melhorar seu Jerk se melhorar o seu agachamento (squat). Isso inclui, além do agachamento normal,
                            fazer um agachamento até a quebra da paralela com subida rápida. Isso lhe dará mais potência para a realização do Jerk.
                        </span>
                    );
                }
            }
            else {
                //////////////////////////////////////////////////////////////////////
                if (worst.name === 'Clean' && worst.ratioDiff < 0) {
                    // Clean too low
                    diagnosis = (
                        <span>
                            De acordo com seus dados, você faz um clean com menos carga do que faz Clean &amp; Jerk.
                            Isso é estatisticamente impossível... Se você consegue fazer o clean, você conseguirá fazer o Clean &amp; Jerk, certo?
                        </span>
                    );
                    prescription = (
                        <span>
                            Verifique os dados inseridos e tente novamente, ok?
                        </span>
                    );
                }
                else if (worst.name === 'Clean' && frontSquat !== undefined) {
                    // Clean too high (and front squat ratio is within range) 
                    if (worst.ratioDiff > 0 && Math.abs(frontSquat.ratioDiff) < frontSquatAcceptableRange) {
                        diagnosis = (
                            <span>
                                Baseado nos dados que você forneceu, como você faz Clean com mais carga do que Clean &amp; Jerk
                                e aparentemente você não está limitado pela sua força no front squat, parece que você possui
                                um problema de eficiência em sua técnica.
                            </span>
                        );
                        prescription = (
                            <span>
                                <p>
                                    Como há uma grande quantidade de quesitos técnicos que podem estar atrapalhando o seu Jerk,
                                    é difícil dizer com os dados informados qual aspecto técnico você precisa melhorar (como por exemplo, posição inadequada ou desequilíbrio, problemas de
                                    quantidade ou direção da potência ou coordenação).
                                </p>
                                <p>
                                    Nós recomendamos você a avaliar seus próprios movimentos em vídeo, ou buscar um coach
                                    experiente para lhe ajudar a priorizar/corrigir suas deficiências técnicas, assim você
                                    conseguirá aproveitar de melhor maneira sua força no Jerk.
                                </p>
                            </span>);
                    }
                    else if (worst.ratioDiff > 0 && frontSquat.ratioDiff < 0) {
                        // Clean too high (and front squat ratio is lower than ideal)
                        diagnosis = (
                            <span>
                                Baseado nos dados que você forneceu, como você faz Clean com mais carga do que Clean &amp; Jerk
                                e como os dados de front squat apontam para um valor abaixo do ideal, seu problema parece ser força de pernas.
                            </span>
                        );
                        prescription = (
                            <span>
                                Você conseguirá melhorar seu Jerk se melhorar o seu agachamento (squat). Isso inclui, além do agachamento normal,
                                fazer um agachamento até a quebra da paralela com subida rápida. Isso lhe dará mais potência para a realização do Jerk.
                            </span>
                        );
                    }
                }
                //////////////////////////////////////////////////////////////////////
                else if (worst.name === 'Back Squat') {
                    if (worst.ratioDiff > 0) {
                        // Back Squat too high
                        diagnosis = (
                            <span>
                                Como sua carga no back squat está acima da ideal comparado ao seu Clean &amp; Jerk, e como
                                esta é a maior disparidade com base nos números que você inseriu, isso nos diz que você possui
                                força para fazer um Clean &amp; Jerk com mais carga. Logo, seu problema aqui não é força e sim
                                alguma ineficiência técnica.
                            </span>
                        );

                        prescription = (
                            <span>
                                <p>
                                    Como há uma grande quantidade de quesitos técnicos que podem estar atrapalhando o seu Jerk,
                                    é difícil dizer com os dados informados qual aspecto técnico você precisa melhorar.
                                </p>
                                <p>
                                    Nós recomendamos você a avaliar seus próprios movimentos em vídeo, ou buscar um coach
                                    experiente para lhe ajudar a priorizar/corrigir suas deficiências técnicas, assim você
                                    conseguirá aproveitar de melhor maneira sua força no Jerk.
                                </p>
                                <p>
                                    <i>Nota</i>: Como sua carga no squat não parece ser o grande limitador para você aqui,
                                    você poderia refazer a análise sem os dados de back squat para afiar sua técnica
                                    de Clean &amp; Jerk. Isso poderá nos dizer qual o outro movimento que apresenta uma
                                    disparidade maior para podermos sugerir melhorias.
                                </p>
                            </span>
                        );
                    }
                    else {
                        // Back Squat too low
                        diagnosis = (
                            <span>
                                Como sua carga de back squat em relação ao clean está abaixo do ideal, e como
                                esta é a maior disparidade dentre os números que você inseriu, isso nos diz
                                que sua maior dificuldade no Clean &amp; Jerk está relacionada a força nas pernas.
                                Se isso ainda não fez com que você já perdesse alguns movimentos, provavelmente você sinta
                                seu Clean &amp; Jerk muito pesado, pois está muito próximo da sua capacidade máxima.
                            </span>
                        );

                        prescription = (
                            <span>
                                Nós recomendamos você focar em fortalecimento de pernas, para que você tenha mais força
                                reserva para fazer os Clean &amp; Jerk com mais facilidade. Você poderá fazer isso
                                com séries de squat e squat com subida rápida.
                            </span>
                        );
                    }
                }
                //////////////////////////////////////////////////////////////////////
                else if (worst.name === 'Front Squat') {
                    if (worst.ratioDiff < 0) {
                        // FS too low
                        diagnosis = (
                            <span>
                                Como sua carga de front squat em relação ao clean está abaixo do ideal, e como
                                esta é a maior disparidade dentre os números que você inseriu, isso nos diz
                                que sua maior dificuldade no Clean &amp; Jerk está relacionada a força nas pernas.
                                Se isso ainda não fez com que você já perdesse alguns movimentos, provavelmente você sinta
                                seu Clean &amp; Jerk muito pesado, pois está muito próximo da sua capacidade máxima.
                            </span>
                        );

                        prescription = (
                            <span>
                                Nós recomendamos você focar em fortalecimento de pernas, para que você tenha mais força
                                reserva para fazer os Clean &amp; Jerk com mais facilidade. Você poderá fazer isso
                                com séries de squat e squat com subida rápida.
                            </span>
                        );
                    }
                    else {
                        // FS too high
                        diagnosis = (
                            <span>
                                Como sua carga no front squat está acima da ideal comparado ao seu Clean &amp; Jerk, e como
                                esta é a maior disparidade com base nos números que você inseriu, isso nos diz que você possui
                                força para fazer um Clean &amp; Jerk com mais carga. Logo, seu problema aqui não é força e sim
                                alguma ineficiência técnica.
                            </span>
                        );

                        prescription = (
                            <span>
                                <p>
                                    Como há uma grande quantidade de quesitos técnicos que podem estar atrapalhando o seu Jerk,
                                    é difícil dizer com os dados informados qual aspecto técnico você precisa melhorar.
                                </p>
                                <p>
                                    Nós recomendamos você a avaliar seus próprios movimentos em vídeo, ou buscar um coach
                                    experiente para lhe ajudar a priorizar/corrigir suas deficiências técnicas, assim você
                                    conseguirá aproveitar de melhor maneira sua força no Jerk.
                                </p>
                                <p>
                                    <i>Nota</i>: Como sua carga no squat não parece ser o grande limitador para você aqui,
                                    você poderia refazer a análise sem os dados de front squat para afiar sua técnica
                                    de Clean &amp; Jerk. Isso poderá nos dizer qual o outro movimento que apresenta uma
                                    disparidade maior para podermos sugerir melhorias.
                                </p>
                            </span>
                        );
                    }
                }
                //////////////////////////////////////////////////////////////////////
                else if (worst.name === 'Jerk') {
                    if (frontSquat === undefined) {
                        // Jerk higher than expected
                        if (worst.ratioDiff > 0) {
                            diagnosis = (
                                <span>
                                    Como sua carga no Jerk está acima da ideal comparado ao seu Clean &amp; Jerk, e como
                                    esta é a maior disparidade com base nos números que você inseriu, isso nos diz que você possui
                                    força para fazer um Clean &amp; Jerk com mais carga. Logo, seu problema aqui não é força e sim
                                    alguma ineficiência técnica na realização do clean.
                                </span>
                            );

                            prescription = (
                                <span>
                                    <p>
                                        Como há uma grande quantidade de quesitos técnicos que podem estar atrapalhando o seu Clean,
                                        é difícil dizer com os dados informados qual aspecto técnico você precisa melhorar.
                                    </p>
                                    <p>
                                        Nós recomendamos você a avaliar seus próprios movimentos em vídeo, ou buscar um coach
                                        experiente para lhe ajudar a priorizar/corrigir suas deficiências técnicas, assim você
                                        conseguirá aproveitar de melhor maneira sua força no Jerk.
                                    </p>
                                    <p>
                                        <i>Nota</i>: Como o Jerk não parece ser seu grande limitador
                                        você poderia realizer a análise sem inserir os dados de Jerk, desta forma saberemos
                                        qual a outra grande disparidade que você possui e poderemos dar melhores sugestões
                                    </p>
                                </span>
                            );
                        }
                        // Jerk lower than expected
                        else {
                            diagnosis = (
                                <span>
                                    Como seu Jerk está abaixo do ideal mas nós não sabemos sua carga no front squat, nossa
                                    análise é limitada. Se o seu squat está dentro do ideal você possivelmente possui problemas de
                                    técnica no Jerk. Se o seu squat está abaixo do ideal, você possui problemas de força e/ou
                                    geração de potência para realização do Jerk.
                                </span>
                            );

                            prescription = (
                                <span>
                                    Por favor insira os dados de seu front squat e execute a análise novamente.
                                </span>
                            );
                        }
                    }
                    else {
                        // Jerk lower than expected (and front squat ratio is within range or above)
                        if (worst.ratioDiff < 0 && Math.abs(frontSquat.ratioDiff) < frontSquatAcceptableRange) {
                            diagnosis = (
                                <span>
                                    Como seu Jerk está abaixo do ideal e de acordo com os dados
                                    de seu front squat, você possui força suficiente, tudo leva a crer que
                                    seu problema é de deficiência técnica no Jerk.
                                </span>
                            );

                            prescription = (
                                <span>
                                    <p>
                                        Como há uma grande quantidade de quesitos técnicos que podem estar atrapalhando o seu Jerk,
                                        é difícil dizer com os dados informados qual aspecto técnico você precisa melhorar (como por exemplo, posição inadequada ou desequilíbrio, problemas de
                                        quantidade ou direção da potência ou coordenação).
                                    </p>
                                    <p>
                                        Nós recomendamos você a avaliar seus próprios movimentos em vídeo, ou buscar um coach
                                        experiente para lhe ajudar a priorizar/corrigir suas deficiências técnicas, assim você
                                        conseguirá aproveitar de melhor maneira sua força no Jerk.
                                    </p>
                                </span>
                            );
                        }

                        // Jerk lower than expected (and front squat ratio is lower than ideal)
                        else if (worst.ratioDiff < 0 && frontSquat.ratioDiff < 0) {
                            diagnosis = (
                                <span>
                                    Como seu Jerk está abaixo do ideal e sua carga no front squat também,
                                    podemos concluir que seu Jerk está limitado por falta de forca.
                                </span>
                            );

                            prescription = (
                                <span>
                                    Nós recomendamos você focar em fortalecimento de pernas, para que você tenha mais força
                                    para fazer o Jerk. Você poderá fazer isso com séries de squat e squat com subida rápida.
                                </span>
                            );
                        }
                    }
                }
                //////////////////////////////////////////////////////////////////////
                else if (worst.name === 'Power Clean') {

                    if (frontSquat === undefined) {
                        // Too low
                        if (worst.ratioDiff < 0) {
                            diagnosis = (
                                <span>
                                    Isso nos diz que você possui pernas fracas ou baixa velocidade de transição/explosão.
                                </span>
                            );

                            prescription = (
                                <span>
                                    Treine para melhorar sua transição/explosão. Insira o valor da sua carga de front squat para uma melhor análise.
                                </span>
                            );
                        }
                        // Too high
                        else {
                            diagnosis = (
                                <span>
                                    Se o seu front squat está dentro do ideal, você provavelmente possui ineficiências técnicas.
                                    Se o seu front squat está abaixo do ideal, seu problema pode ser força, mobilidade ou ambos.
                                </span>
                            );

                            prescription = (
                                <span>
                                    Se sua carga no front squat está dentro do ideal, faça exercícios de
                                    mobilidade relacionados ao Clean &amp; Jerk. Se sua carga no front squat está
                                    abaixo do ideal, invista um tempo em treinos de fortalecimento de pernas.
                                    Para uma análise futura, insira os valores de front squat.
                                </span>
                            );
                        }
                    }
                    else {

                        if (worst.ratioDiff < 0) {
                            // PCL lower than expected (front squat within or above ideal range)
                            if (frontSquat.ratioDiff + frontSquatAcceptableRange >= 0) {
                                diagnosis = (
                                    <span>
                                        Como sua carga no power clean está abaixo do ideal comparada com seu Clean &amp; Jerk,
                                        e como você não possui ineficiências com front squat, tudo leva a crer que você está
                                        limitado por falta de explosão no movimento ou sua entrada embaixo da barra no clean
                                        não está rápida o suficiente.
                                    </span>
                                );

                                prescription = (
                                    <span>
                                        Nós recomendamos você a melhorar sua explosão e velocidade de entrada embaixo da barra
                                        nos cleans. Você pode fazer isso trabalhando em cleans/power cleans partindo da posição de
                                        hang ou utilizando blocos de suporte para melhorar sua velocidade e mudança de direção,
                                    </span>
                                );
                            }
                            // PCL lower than expected (front squat below ideal range)
                            else {
                                diagnosis = (
                                    <span>
                                        Como sua carga no power clean está abaixo do ideal comparado com seu Clean &amp; Jerk
                                        e sua carga no front squat também está abaixo do ideal, seu problema deve ser
                                        falta de força de explosão e/ou você está fraco na posição de recepção da barra no clean.
                                    </span>
                                );

                                prescription = (
                                    <span>
                                        Nós recomendamos você a melhorar sua força de explosão e sua força na recepção da barra no clean.
                                        Você poderá fazer isso realizando front squats e front squats parciais (para melhorar sua força na posição de
                                        recepção da barra), cleans e power cleans da posição de power e da posição de hang (para ajudar na velocidade e na
                                        mudança de direção) e cleans e power cleans a partir de blocos de suporte.
                                    </span>
                                );
                            }
                        }
                        else { // PCL higher than expected
                            // PCL higher than expected (front squat within or above ideal range)
                            if (frontSquat.ratioDiff + frontSquatAcceptableRange >= 0) {
                                diagnosis = (
                                    <span>
                                        Como seu power clean está acima do ideal comparado com seu Clean &amp; Jerk,
                                        mas sua carga no front squat sugere que você possui força suficiente, isso nos
                                        leva a crer que seu problema é uma ineficiência técnica na recepção da barra no clean (posição de pés,
                                        velocidade de cotovelos, e potencialmente posição de tronco).
                                    </span>
                                );

                                prescription = (
                                    <span>
                                        Primeiramente nós recomendamos que você verifique novamente se sua
                                        posição de recepção da barra nos cleans está adequada (similar ao seu
                                        front squat). Se sua posição de recepção não está boa você poderia melhorar
                                        fazendo alguns exercícios de mobilidade.
                                        Assumindo que sua posição de recepção da barra esteja ok, você terá melhorias
                                        treinando cleans/power cleans a partir de blocos de suporte ou a partir da
                                        posição de hang. Isso vai lhe ajudar a focar em uma recepção de barra mais eficiente.
                                    </span>
                                );
                            }
                            // PCL higher than expected (and front squat ratio is lower than ideal)
                            else {
                                diagnosis = (
                                    <span>
                                        Como sua carga no power clean está acima do ideal comparado com seu Clean &amp; Jerk,
                                        mas sua carga no front squat está abaixo do ideal, isso sugere que você possui uma
                                        limitação de força. Se sua postura não é boa, isso pode ser um problema de mobilidade também.
                                    </span>
                                );

                                prescription = (
                                    <span>
                                        Nós recomendamos você a trabalhar para ter uma boa posição de recepção da barra.
                                        Se você não está com uma boa posição de recepção, você pode fazer alguns exercícios de
                                        mobilidade. Se sua posição de recepção da barra está adequada, seu foco deverá ser
                                        aumentar sua força de pernas, para fazer isso, realize agachamentos e agachamentos com
                                        subida rápida.
                                    </span>
                                );
                            }
                        }
                    }

                    // // PCL lower than expected
                    // if(worst.ratioDiff < 0) {
                    //     diagnosis = "This tells us you may suffer from poor explosion/transition speed.";
                    //     prescription = "You should work on improving your explosion and your change of direction speed (getting under bar faster)";
                    // }

                    // // PCL higher than expected (and front squat ratio is within range)
                    // else if(frontSquat !== undefined && Math.abs(frontSquat.ratioDiff) < frontSquatAcceptableRange) {
                    //     diagnosis = "Since your front squat is within acceptable range, you likely have technical inefficiencies in your clean & jerk.";
                    //     prescription = "We recommend you analyze (or get coaching help to analyze) your clean & jerk technique and work on fixing it.";
                    // }

                    // // PCL higher than expected (and front squat ratio is lower than ideal)
                    // else if(frontSquat !== undefined && frontSquat.ratioDiff < 0) {
                    //     diagnosis = "Since your front squat is lower than the acceptable range, you may be lacking strength, mobility, or both.";
                    //     prescription = "We recommend you spend some time getting your legs stronger and/or improving your mobility";
                    // }
                }
                //////////////////////////////////////////////////////////////////////
                else if (worst.name === 'Clean Blocks Abv Knee') {
                    // Lower than ideal
                    if (worst.ratioDiff < 0) {
                        diagnosis = (
                            <span>
                                Como seu clean a partir de blocos de suporte está abaixo do ideal em
                                relação ao seu Clean &amp; Jerk e como esta é a maior disparidade que você
                                possui, isso nos diz que sua maior fraqueza é a explosão vertical.
                            </span>
                        );

                        prescription = (
                            <span>
                                Nós recomendamos você a fazer treinamentos que melhorem sua explosão como por
                                exemplo, box jumps, squat parcial com sobrecarga e jumping squats com a barra.
                            </span>
                        );
                    }
                    // Higher than ideal
                    else {
                        diagnosis = (
                            <span>
                                Como seu clean a partir de blocos de suporte está acima do ideal em
                                relação ao seu Clean &amp; Jerk e como esta é sua maior disparidade,
                                isso sugere que seu problema no clean está ao movimentar a barra do solo
                                até a altura dos joelhos. Isso pode ser um problema de força para levantar a barra
                                até os joelhos ou um problema de coordenação após a barra passar dos joelhos.
                            </span>
                        );

                        prescription = (
                            <span>
                                Nós recomendamos você a realizar exercícios que melhorem a arrancada da
                                barra do solo até passar dos joelhos. Isso pode incluir exercícios como
                                puxada de clean até o joelho e puxada de clean até o quadril. Você também pode
                                inserir levantamentos de hang clean partindo abaixo do joelho.
                            </span>
                        );
                    }
                }
                //////////////////////////////////////////////////////////////////////
                else if (worst.name === 'Hang Clean Below Knee') {
                    // Lower than ideal
                    if (worst.ratioDiff < 0) {
                        diagnosis = (
                            <span>
                                Como seu hang clean partindo abaixo do joelho está abaixo do ideal em
                                relação ao seu Clean &amp; Jerk e como esta é sua maior disparidade, isso
                                nos leva a crer que você possui pouca força de costas ou problemas de coordenação
                                quando a barra passa do seu joelho.
                            </span>
                        );

                        prescription = (
                            <span>
                                Se for um problema de falta de força nas costas, nós recomendamos que você
                                faça exercícios como Deadlift, elevação de clean até o quadril e extensão lombar.
                                Se for um problema de coordenação, você pode praticar movimentos que iniciem
                                abaixo do joelho, como hang cleans e power cleans.
                            </span>
                        );
                    }
                    // Higher than ideal
                    else {
                        diagnosis = (
                            <span>
                                Como seu hang clean abaixo do joelho está acima do ideal comparado
                                ao seu Clean &amp; Jerk e como esta é a maior disparidade que você possui,
                                isso nos leva a crer que sua dificuldade está em arrancar a barra do chão.
                            </span>
                        );

                        prescription = (
                            <span>
                                Nós recomendamos que você faça mais exercícios partindo com a barra do chão,
                                como puxadas de clean até o joelho e outros levantamentos de peso partindo do chão.
                            </span>
                        );
                    }
                }
                //////////////////////////////////////////////////////////////////////
                else if (worst.name === 'Overhead Squat') {
                    // OHS lower than ideal
                    if (worst.ratioDiff < 0) {
                        diagnosis = (
                            <span>
                                Como sua carga no Overhead squat está abaixo do ideal em relação ao seu snatch e como esta
                                é a maior disparidade que você possui, isso sugere que você possui um problema com estabilidade
                                na posição de recepção da barra no snatch.
                            </span>
                        );

                        prescription = (
                            <span>
                                Nós recomendamos que você invista um tempo aumentando sua capacidade de carga no overhead e
                                em estabilização. Você pode fazer isso com exercícios como levantamentos restritos incluindo pegadas de snatch e
                                clean.
                            </span>
                        );
                    }
                    // OHS higher than ideal
                    else {
                        diagnosis = (
                            <span>
                                A maior disparidade de carga que você possui é no overhead squat comparado com sua carga de snatch.
                                Aparentemente seu overhead squat está acima do ideal para um atleta em equilíbrio. Infelizmente isso
                                não nos diz muito (exceto é claro pelo fato de que o OHS não é um limitador de força para você).
                            </span>
                        );

                        prescription = (
                            <span>
                                Tenho uma boa e uma má notícia para você: Um OHS acima do ideal em si não um problema. Mas isso também
                                não nos diz muita coisa sobre o restante do seu equilíbrio como um levantador de peso. Sendo assim, nós
                                não temos uma prescrição direta para este caso, já que o OHS não é um limitador para você. Você pode refazer
                                a análise removendo o valor de OHS, assim a calculadora irá buscar outros fatores que possam melhorar seu snatch.
                            </span>
                        );
                    }
                }
                //////////////////////////////////////////////////////////////////////
                else if (worst.name === 'Power Snatch') {
                    // Lower than ideal
                    if (worst.ratioDiff < 0) {
                        diagnosis = (
                            <span>
                                Como seu power snack está abaixo do ideal em relação a sua carga de snatch,
                                e como esta é a maior disparidade de valores que você possui, você possui uma limitação
                                de explosão de força e/ou velocidade de entrada embaixo da barra.
                            </span>
                        );

                        prescription = (
                            <span>
                                Nós recomendamos que você trabalhe para melhorar sua velocidade de entrada embaixo
                                da barra, você pode fazer isso treinando movimentos de hang snatch e de snatch a partir
                                de blocos de suporte.
                            </span>
                        );
                    }
                    else {
                        diagnosis = (
                            <span>
                                Como sua carga no power snatch está acima do ideal, o que deve estar limitando
                                você é uma questão de força ou de confiança em entrar embaixo da barra.
                            </span>
                        );

                        prescription = (
                            <span>
                                Para melhorar sua força e confiança na posição de recepção da barra no snatch,
                                você pode treinar snatch balance, overhead squat, overhead squat com pausa e
                                movimentos de press com pegada de snatch (sentado, de pé e em posição de agachamento).
                            </span>
                        );
                    }
                }
                //////////////////////////////////////////////////////////////////////
                else if (worst.name === 'Snatch Blocks Abv Knee') {
                    // Lower than ideal
                    if (worst.ratioDiff < 0) {
                        diagnosis = (
                            <span>
                                Como sua carga máxima no snatch a partir de blocos de suporte está abaixo do ideal
                                comparado com seu snatch e como esta é a maior disparidade de valores, isso nos
                                diz que sua dificuldade esta na explosão vertical.
                            </span>
                        );

                        prescription = (
                            <span>
                                Nós recomendamos você a treinar movimentos como box jump, squat parcial com
                                sobrecarga e jumping squat com a barra.
                            </span>
                        );
                    }
                    // Higher than ideal
                    else {
                        diagnosis = (
                            <span>
                                Como sua capacidade de carga no snatch a partir de blocos de suporte
                                está acima do ideal comparado ao snatch e esta é a maior disparidade encontrada,
                                isso nos diz que sua dificuldade está em arrancar a barra do solo até a altura dos joelhos.
                                Isso pode ser um problema de força ou de coordenação.
                            </span>
                        );

                        prescription = (
                            <span>
                                Nós recomendamos você a treinar movimentos que iniciem com a barra no chão e terminem
                                acima dos joelhos, isso pode incluir puxadas de snatch ate o joelho, puxadas de snatch até o quadril
                                e você pode incluir também entradas de hang snatch abaixo do joelho.
                            </span>
                        );
                    }
                }
                //////////////////////////////////////////////////////////////////////
                else if (worst.name === 'Hang Snatch Below Knee') {
                    if (worst.ratioDiff < 0) {
                        diagnosis = (
                            <span>
                                Como sua carga no hang snatch abaixo do joelho está abaixo do ideal em relação
                                a sua carga de snatch e como esta é a maior disparidade de valor encontrada,
                                isso significa que você possui pouca forca nas costas ou problemas de coordenação
                                quando a barra passa dos joelhos.
                            </span>
                        );

                        prescription = (
                            <span>
                                Se for um problema de falta de força nas costas, nós recomendamos que você
                                faça exercícios como Deadlift (com pegada normal e pegada de snatch), elevação de snatch até o quadril e extensão lombar.
                                Se for um problema de coordenação, você pode praticar movimentos que iniciem
                                abaixo do joelho, como hang snatch e hang power snatch.
                            </span>
                        );
                    }
                    else {
                        diagnosis = (
                            <span>
                                Como sua capacidade de carga no hang snatch abaixo do joelho está
                                acima do ideal em relação ao seu snatch e como esta é a maior disparidade
                                encontrada, isso nos diz que sua dificuldade é ao arrancar com a barra do solo.
                            </span>
                        );

                        prescription = (
                            <span>
                                Nós recomendamos você a treinar movimentos que iniciem com a barra no chão e terminem
                                acima dos joelhos, isso pode incluir puxadas de snatch ate o joelho, puxadas de snatch até o quadril
                                e você pode incluir também entradas de hang snatch abaixo do joelho.
                            </span>
                        );
                    }
                }

                if (results.length > 1) {
                    shortExplanation = (
                        <p>
                            Baseado nos dados que você inseriu, a maior disparidade está no movimento de <u>{worst.name}</u>.
                        </p>
                    );
                }

            }

            // Create the generic description text for this calculation
            let description = `O ideal é que seu ${worst.name} seja
                ${formatNumber(worst.expectedRatio)}% do seu ${this.props.baseName}, entretanto o seu
                ${worst.name} está a ${formatNumber(worst.actualRatio)}% 
                do seu ${this.props.baseName}. Isto é uma diferença de ${formatNumber(worst.ratioDiff)}%.`

            let work = null;
            if (showWork) {
                work = (
                    <span>
                        <h3>Como chegamos a esta conclusão?</h3>
                        {description}
                        {extraWork}
                    </span>
                );
            }

            // Create the HTML to display the diagnosis/prescription/description
            resultsContent = (
                <span>
                    {shortExplanation}

                    <h3>Diagnóstico</h3>
                    {diagnosis}

                    <h3>Prescrição</h3>
                    {prescription}

                    {work}

                    <p>
                        <i>{notes}</i>
                    </p>
                </span>);
        }

        return (
            <div style={{ backgroundImage: `url(/img/prancheta_2.png)` }} className="panel panel-danger">
                <div className="panel-heading">
                    {/* <h3 className="panel-title">{analysisName}</h3> */}
                    {analysisName}
                </div>
                <div className="panel-body" style={{ textAlign: 'left' }}>
                    {resultsContent}
                </div>
            </div>
        );
    }
}

export { AccessoryResults };
// vim: filetype=javascript.jsx



/** WEBPACK FOOTER **
 ** ./src/components/accessoryresults.js
 **/